module.exports = "/images/backgroundDesktopLoading.svg";